const SERVER_API_URL = "http://localhost:8888"; // process.env.REACT_APP_SERVER_URL;


export default SERVER_API_URL;
